<template>
	<el-dialog title="详情" v-model="isDetail" width="40%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="page_warp scroll-view">
			<div class="input_img_row">
				<div class="input_lable">用户头像：</div>
				<div class="input_box">
					<div class="blank-img" style="border-radius: 50%">
						<img style="border-radius: 50%" width="72" height="72" src="@/assets/images/icon-user-bg.png"
							alt="" v-if="!dataItem.userHeadImg" />
						<img :src="dataItem.userHeadImg" alt="" width="72" height="72" style="border-radius: 50%"
							v-else />
					</div>
				</div>
			</div>

			<div class="input_row">
				<div class="input_lable">登录账号：</div>
				<div class="input_box">
					<el-input type="text" placeholder="请输入" disabled v-model="dataItem.userLgname" />
				</div>
			</div>

			<div class="input_row">
				<div class="input_lable">用户姓名：</div>
				<div class="input_box">
					<el-input type="text" placeholder="请输入" disabled v-model="dataItem.userNickname" />
				</div>
			</div>

			<div class="input_row">
				<div class="input_lable">身份证号：</div>
				<div class="input_box">
					<el-input type="text" placeholder="请输入" disabled v-model="dataItem.userCardid" />
				</div>
			</div>

			<div class="input_row">
				<div class="input_lable">手机号码：</div>
				<div class="input_box">
					<el-input type="text" placeholder="请输入" v-model="dataItem.userPhone" disabled />
				</div>
			</div>

			<div class="input_row">
				<div class="input_lable">角色管理：</div>
				<div class="input_box">
					<el-select placeholder="请选择角色" multiple v-model="dataItem.roleList" disabled>
						<el-option v-for="item in roleList" :label="item.roleName" :value="item.roleId"
							:key="item.roleId"></el-option>
					</el-select>
				</div>
			</div>

			<div class="input_row">
				<div class="input_lable">用户状态：</div>
				<div class="input_box">
					<el-switch v-model="dataItem.userState" active-text="正常" inactive-text="禁用" disabled>
					</el-switch>
				</div>
			</div>

<!-- 			<div class="input_row">
				<div class="input_lable">所属部门：</div>
				<div class="input_box selectTree">
					<el-input v-model="valueTitle" class="cursor" disabled placeholder="请选择部门">
					</el-input>
				</div>
			</div> -->

			<div class="footer_btn_warp">
				<div class="confirm_btn" @click="closeModal()">关闭</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isPhone,
		isIdNo
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	export default defineComponent({
		name: "Detail",
		emits: ["getData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};
			onMounted(() => {
				nextTick(() => {});
			});
			const data = reactive({
				isDetail: false,
				treeData: [],
				roleList: [],
				defaultProps: {
					children: "children",
					label: "text",
				},
				valueTitle: "",
				isShowTree: false,
				dataItem: {
					userLgname: "", //角色账号
					userNickname: "", //角色名
					userHeadImg: "", //头像
					userPhone: "", //手机号
					userCardid: "", //身份证
					roleList: [], //选中的角色id
					userState: true, //用户状态 0正常 1禁用
					userStatus: 0,
					deptNo: "",
					userId: "", //用户id
				},
			});
			//重置数据
			const init = (id) => {
				data.isDetail = true;
				console.log(id);
				getDetail(id);
			};
			const getDetail = async (id) => {
				data.dataItem.userId = id;
				let params = {
					userId: id,
				};
				const r = await proxy.$http.get(apiObj.userDetail, params);
				console.log(r);
				if (r) {
					data.dataItem.userLgname = r.userInfo.userLgname;
					data.dataItem.userNickname = r.userInfo.userNickname;
					data.dataItem.userHeadImg = r.userInfo.userHeadImg;
					data.dataItem.userPhone = r.userInfo.userPhone;
					data.dataItem.userCardid = r.userInfo.userCardid;
					data.dataItem.deptNo = r.userInfo.deptNo;
					data.valueTitle = r.userInfo.deptName;
					data.dataItem.userStatus = r.userInfo.userStatus;
					if (Number(r.userInfo.userStatus) === 0) {
						data.dataItem.userState = true;
					}
					if (Number(r.userInfo.userStatus) === 1) {
						data.dataItem.userState = false;
					}
					data.dataItem.roleList = r.userInfo.roleList;

					getRoleList();
				}
			};

			//角色列表
			const getRoleList = async () => {
				const r = await proxy.$http.get("/auth/bdzl/role/userRoleList", {});
				if (r.code === 0 || r.respCode === "0000") {
					data.roleList = r.rows;
				}
			};

			const dialogClosedHandle = () => {
				data.isDetail = false;
			};
			const closeModal = () => {
				data.isDetail = false;
			};

			const closeTree = () => {
				data.isShowTree = false;
			};
			return {
				...toRefs(data),
				init,
				closeModal,
				getData,
				getRoleList,

				dialogClosedHandle,

				closeTree,
				getDetail,
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.input_img_row {
		width: 100%;
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	:deep(.el-select) {
		width: 100%;
	}
</style>